<template>
  <svg width="17" height="29" viewBox="0 0 17 29" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M14.3747 0.939331L0.939707 14.3744L3.06103 16.4957L3.07195 16.485L14.7283 28.1421L16.8496 26.0208L5.19295 14.363L16.4961 3.06065L14.3747 0.939331Z" fill="#010101"/>
  </svg>
</template>